import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  LoginImg1,
  LoginImg2,
  LoginImg3,
  logo,
  NetIcon1,
  NetIcon2,
} from "../../imagepath";
import FeatherIcon from "feather-icons-react";
import { Link } from "react-router-dom";
import AuthContext from "../../../context/AuthContext";
import PaymentPage from "../../payment/card";
import Loader from "../../common/loader";
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/css/bootstrap.min.css';
const Login = () => {
  const [passwordType, setPasswordType] = useState("password");
  const navigate = useNavigate();
  const [showPayment, setShowPayment] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState();
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const discountUrl = new URLSearchParams(window.location.search);
    if (discountUrl.get("email"))
      setForm(prevForm => ({ ...prevForm, email: discountUrl.get("email") }));
  }, []);

  const togglePassword = () => {
    setPasswordType(passwordType === "password" ? "text" : "password");
  };

  const { loginUser } = useContext(AuthContext);
  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const response = await loginUser(form);
      setLoading(false);
      console.log("Login response:", response);

      // Check if password must be changed
      if (response && response.mustChangePassword === true && response.resetToken) {
        console.log("Login component: Password change required, redirecting...");
        console.log("Reset token:", response.resetToken);
        console.log("Email:", response.email);
        // Use window.location.href for guaranteed redirect (bypasses React Router if needed)
        const resetUrl = `/reset-password/${response.resetToken}?type=teacher${response.email ? '&email=' + encodeURIComponent(response.email) : ''}`;
        console.log("Redirecting to:", resetUrl);
        window.location.href = resetUrl;
        return;
      }

      // Standardize role to string for consistent handling
      const role = String(response.role);
      console.log("Login: Standardized role:", role, "Original:", response.role);

      // Skip payment check for state admin (role 4) - they're invoiced separately
      if (role === "4") {
        // Clear any payment flags
        localStorage.removeItem("needsPayment");
        localStorage.removeItem("paymentDetails");
        setPaymentDetails(null);
        setShowPayment(false);
        // Store stateid for state admin dashboard
        if (response.stateid) {
          localStorage.setItem("stateid", response.stateid);
        }
        // Navigate to state dashboard
        navigate("/admin/state-dashboard");
        return;
      }

      // Multi-school admin - invoiced separately (no payment/quiz gate). Store the
      // managed schools + default active school, then land on the school dashboard.
      if (role === "multi_school_admin") {
        localStorage.removeItem("needsPayment");
        localStorage.removeItem("paymentDetails");
        setPaymentDetails(null);
        setShowPayment(false);

        const schools = Array.isArray(response.schools) ? response.schools : [];
        localStorage.setItem("managedSchools", JSON.stringify(schools));
        // Preserve a previously-selected school if it is still in the managed set.
        const prev = localStorage.getItem("activeSchoolId");
        const stillValid = prev && schools.some((s) => String(s.id) === String(prev));
        const defaultId = stillValid ? prev : (schools[0] && schools[0].id);
        if (defaultId) {
          localStorage.setItem("activeSchoolId", String(defaultId));
        }

        navigate("/main-dashboard");
        return;
      }

      if (response.is_payment === false) {
        setPaymentAmount(response.amount);
        setShowPayment(true);
        // Store payment details for banner display and payment form
        // Check for paymentDetails object first (from backend)
        let paymentDetailsObj = null;
        if (response.paymentDetails) {
          paymentDetailsObj = response.paymentDetails;
          localStorage.setItem("needsPayment", "true");
          localStorage.setItem("paymentDetails", JSON.stringify(response.paymentDetails));
        } else if (response.payment) {
          // Alternative field name
          paymentDetailsObj = response.payment;
          localStorage.setItem("needsPayment", "true");
          localStorage.setItem("paymentDetails", JSON.stringify(response.payment));
        } else if (response.amount && response.amount > 0) {
          // Fallback: create payment details from amount and other fields
          const totalAmt = response.totalAmount || response.amount;
          paymentDetailsObj = {
            amount: response.amount,
            totalAmount: totalAmt,
            planType: response.planType || "annual",
            installmentsTotal: response.installmentsTotal || 12,
            // ONLY use backend-provided installmentAmount - NO client-side calculations
            installmentAmount: response.installmentAmount || 0,
            installmentsPaid: response.installmentsPaid || 0,
          };
          localStorage.setItem("needsPayment", "true");
          localStorage.setItem("paymentDetails", JSON.stringify(paymentDetailsObj));
        } else {
          // If amount is 0 or missing, don't set payment flag
          console.warn("Payment required but amount is 0 or missing:", response);
          // Don't return early - allow normal login flow to continue
          // Clear payment flags and proceed with navigation
          localStorage.removeItem("needsPayment");
          localStorage.removeItem("paymentDetails");
          setPaymentDetails(null);
          // Continue to navigation logic below instead of returning
        }

        // Only return early if we actually have payment details to show
        if (paymentDetailsObj && (paymentDetailsObj.amount > 0 || paymentDetailsObj.totalAmount > 0)) {
          setPaymentDetails(paymentDetailsObj);
          return;
        }

        // If no valid payment details, clear flags and continue
        localStorage.removeItem("needsPayment");
        localStorage.removeItem("paymentDetails");
        setPaymentDetails(null);
      } else {
        // Clear payment flags if payment is not needed
        localStorage.removeItem("needsPayment");
        localStorage.removeItem("paymentDetails");
      }
      if (response.is_quiz_completed === true) {
        console.log("Login: Quiz completed, switching on role:", role);
        switch (role) {
          case "1":
            console.log("Login: Navigating to /main-dashboard (School Admin)");
            navigate("/main-dashboard");
            break;
          case "2":
            console.log("Login: Navigating to /main-dashboard (School Teacher)");
            navigate("/main-dashboard");
            break;
          case "3":
            console.log("Login: Navigating to /main-dashboard (Teacher)");
            navigate("/main-dashboard");
            break;
          case "4":
            console.log("Login: Navigating to /admin/state-dashboard");
            navigate("/admin/state-dashboard");
            break;
          case "admin":
            console.log("Login: Navigating to /admin/admin-dashboard");
            navigate("/admin/admin-dashboard");
            break;
          default:
            console.warn("Login: Unknown role in quiz completed switch:", role);
        }
      } else {
        console.log("Login: Quiz NOT completed, switching on role:", role);
        switch (role) {
          case "1":
            console.log("Login: Navigating to /main-dashboard (School Admin)");
            navigate("/main-dashboard");
            break;
          case "2":
            console.log("Login: Navigating to /main-dashboard (School Teacher)");
            navigate("/main-dashboard");
            break;
          case "3":
            console.log("Login: Navigating to /main-dashboard (Teacher)");
            navigate("/main-dashboard");
            break;
          case "4":
            console.log("Login: Navigating to /admin/state-dashboard");
            navigate("/admin/state-dashboard");
            break;
          case "admin":
            console.log("Login: Navigating to /admin/admin-dashboard");
            navigate("/admin/admin-dashboard");
            break;
          default:
            console.warn("Login: Unknown role in quiz NOT completed switch:", role);
        }
      }
    } catch (err) {
      setLoading(false);
      console.error("Login error:", err);
      console.error("Login error details:", {
        message: err?.message,
        response: err?.response?.data,
        status: err?.response?.status,
        statusText: err?.response?.statusText,
        code: err?.code,
      });
      // Ensure error alert is shown - extract message from response
      const { showErrorAlert } = require("../../../services/AlertService");
      let errorMessage = "Login failed. Please try again.";

      if (err?.response?.data?.error) {
        errorMessage = err.response.data.error;

        // Enhance school payment error message
        if (errorMessage.includes("School Payment Error")) {
          errorMessage = "Your school's payment has expired. Please contact your school administrator to renew the subscription.";
        }
      } else if (err?.response?.status === 404) {
        errorMessage = "User not found. Please check your email and password.";
      } else if (err?.response?.status === 401) {
        errorMessage = "Invalid credentials. Please check your email and password.";
      }

      showErrorAlert({ response: { data: { error: errorMessage } } });
    }
  };

  // Carousel slides data
  const slides = [
    {
      image: LoginImg1,
      title: "Welcome to ",
      subtitle: " AngelWatchLMS Courses",
      content: `The AngelWatch National Certification Program is the first
      and only emergency training system of its kind—specifically designed to prepare teachers, school
      staff, and childcare providers to respond instantly and effectively in real-world crisis situations. Developed
      after 9/11 and previously used to protect U.S. government facilities around the world, this elite training is now
      available for civilian application for the very first time.
      <br /><strong>AngelWatch is:</strong><br />
      Partnered with the American Red Cross and the American Heart Association, and backed by the Department of Homeland Security — built in collaboration with the Department of Defense and the Department of Emergency Management.`
    },
    {
      image: LoginImg2,
      title: "Welcome to ",
      subtitle: " AngelWatchLMS Courses",
      content: `Legal Notice: All training content, techniques, software
      systems, and hardware demonstrated within the AngelWatch Certification Program are copyrighted, trademarked, and
      patented in the United States. This intellectual property is the exclusive legal property of AngelWatch and is
      protected by federal law. Unauthorized use, reproduction, adaptation, or the creation of derivative courses or
      materials based on this program is strictly prohibited and will result in legal action. Any individual or
      organization found attempting to mimic, copy, or alter any aspect of the AngelWatch training system will be held
      accountable to the fullest extent of the law. We maintain strict protection of this content to ensure that the
      quality, accuracy, and life-saving integrity of our training is never compromised or "dumbed down." This is
      critical to ensuring the safety of your staff, teachers, and the children in your care.`
    },
    {
      image: LoginImg3,
      title: "Welcome to ",
      subtitle: " AngelWatchLMS Courses",
      content: `It is fully online, available on-demand 24/7, and provides
      12 months of unlimited access for your entire staff—making it ideal for initial training, new hires, and
      recertification without disrupting your operations. Each center also receives a FREE Emergency Management Protocol
      Handbook, making you instantly compliant with state-mandated emergency planning—with no extra work. This
      course is so unique and valuable, it is copyrighted, trademarked, and patented in the United States. AngelWatch
      doesn't just teach policies. It trains instinct, builds confidence, and saves lives. Train now. Be ready. Stay
      alive. Due to the nature of this training and the sensitive security content involved, all AngelWatch
      Certification Program purchases are final. Because our course materials are designed to protect children, staff,
      and educational facilities—and include proprietary, copyrighted, and patented content—no refunds will be
      issued after enrollment. We appreciate your understanding and commitment to safety.`
    }
  ];

  return (
    <div className="main-wrapper log-wrap">
      <Loader loading={loading} />
      {!showPayment ? (
        <div className="row">
          {/* Login Banner with Bootstrap Carousel */}
          <div className="col-md-6 login-bg">
            <div id="loginCarousel" className="carousel slide" data-bs-ride="carousel">
              <div className="carousel-inner">
                {slides.map((slide, index) => (
                  <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={index}>
                    <div className="welcome-login">
                      <div className="login-banner">
                        <img src={slide.image} className="d-block w-100" alt={`Slide ${index + 1}`} />
                      </div>
                      <div className="mentor-course text-center">
                        <h2 style={{ fontFamily: "Fredoka" }}>
                          {slide.title}
                        </h2>
                        <h1 style={{ fontFamily: "Fredoka", color: "white", fontWeight: "bold" }}>
                          {slide.subtitle}
                        </h1>
                        <p
                          style={{ fontFamily: "Poppins" }}
                          dangerouslySetInnerHTML={{ __html: slide.content }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#loginCarousel"
                data-bs-slide="prev"
              >
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                {/* <span className="visually-hidden">Previous</span> */}
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#loginCarousel"
                data-bs-slide="next"
              >
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>

          {/* Login Form */}
          <div className="col-md-6 login-wrap-bg">
            <div className="login-wrapper">
              <div className="loginbox">
                <div className="w-100">
                  <div className="img-logo">
                    <img src={logo} className="img-fluid" alt="Logo" />
                    <div className="back-home">
                      <a href="https://angelwatchedu.org">Back to Home</a>
                    </div>
                  </div>
                  <h1>Sign into Your Account</h1>
                  <form onSubmit={handleSubmit}>
                    <div className="input-block">
                      <label className="form-control-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter your email address"
                        value={form.email}
                        onChange={(e) =>
                          setForm({ ...form, email: e.target.value })
                        }
                        autoComplete="email"
                        required
                      />
                    </div>
                    <div className="input-block">
                      <label className="form-control-label">Password</label>
                      <div className="pass-group">
                        <input
                          type={passwordType}
                          name="password"
                          className="form-control"
                          placeholder="Password"
                          value={form.password}
                          onChange={(e) =>
                            setForm({ ...form, password: e.target.value })
                          }
                          autoComplete="current-password"
                          required
                        />
                        <span
                          className="toggle-password feather-eye"
                          onClick={togglePassword}
                        >
                          {passwordType === "password" ? (
                            <FeatherIcon icon="eye" />
                          ) : (
                            <FeatherIcon icon="eye-off" />
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="forgot">
                      <span>
                        <Link className="forgot-link" to={`/forgot-password`}>
                          Forgot Password ?
                        </Link>
                      </span>
                    </div>
                    <div style={{ marginBottom: 10 }} className="d-grid">
                      <button className="btn btn-start" type="submit">
                        Sign In
                      </button>
                    </div>
                    <div className="d-grid">
                      {/* <p className="no__account">Don't have an account ? </p> */}
                      <Link to="/selectregister">
                        <button className="btn btn-start">Sign Up</button>
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <PaymentPage
          amount={paymentAmount}
          totalAmount={paymentDetails?.totalAmount || paymentAmount}
          installmentAmount={paymentDetails?.installmentAmount || 0}
          onSuccess={(response, selectedPlanType) => {
            console.log("Payment Successful", response, selectedPlanType);
            setShowPayment(false);
          }}
          pageType="login"
        />
      )}
    </div>
  );
};

export default Login;